import React, { useState, useEffect } from "react";
import { Box, Button, Container, styled } from "@mui/material";
import DesktopMenu from "./component/DesktopMenu";
import MobileMenu from "./component/MobileMenu";
import PurpleButton from "../PurpleButton";

const MainMenu = styled(Container)`
  z-index: 501 !important;
`;

const LockerMenu = (props) => {
  const [topPosition, setTopPosition] = useState(40);
  const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);

  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
    const visible = prevScrollPos > currentScrollPos;

    setTopPosition(visible ? 40 : -100);
    setPrevScrollPos(currentScrollPos);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPos]);

  const menuList = [
    {
      title: "Shadow Ecosystem",
      link: "#shadowecosystem",
      zindex: "10999999",
    },
    // {
    //   title: "Why Shadow Node dVPN",
    //   link: "#whyshadownode",
    //   zindex: "109999",
    // },
    {
      title: "Pricing",
      link: "#pricing",
      zindex: "109999",
    },
    {
      title: "Bridge",
      link: "https://bridge.shadownode.org/",
      zindex: "109999",
        target: "blank",
    },
    {
      title: "Testimonials",
      link: "#testimonials",
      zindex: "109999",
    },
    // {
    //   title: "White Label",
    //   link: "#",
    //   target: "blank",
    //   zindex: "109999",
    // }, 
    {
      title: "FAQs",
      link: "#faqs",
      target: "",
      zindex: "109999",
    },

    {
      title: (
        <Box style={{justifyItems:'center'}}>
        <PurpleButton href="https://app.shadownode.org/" p="7px 25px" target="blank" sx={{fontSize:"17px !important",minWidth: "150px !important",borderRadius: "8px !important",}}>
          Access Dashboard
        </PurpleButton>
           </Box>
      ),
      link: "#",
      p: "0 8px 0 5px",
    }, 
 

  ];

  return (
    <MainMenu maxWidth="xl" >
      <DesktopMenu menuList={menuList} />
      <MobileMenu menuList={menuList} />
    </MainMenu>
  );
};

export default LockerMenu;
